.root {
  align-items: center;
  background: var(--color-background);
  border-bottom: 1px solid var(--color-border);
  display: flex;
  height: 56px;
  justify-content: space-between;
  padding: 0 24px;
}

.left {
  align-items: center;
  display: flex;
  gap: 8px;
  height: 100%;
}

.toggleBtn {
  align-items: center;
  background: none;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  display: flex;
  height: 32px;
  justify-content: center;
  width: 32px;

  &:hover {
    background: var(--color-secondary);
  }
}

.toggleIcon {
  color: var(--color-foreground);
  height: 20px;
  width: 20px;
}

.breadcrumbs {
  align-items: center;
  display: flex;
}

.crumbWrap {
  align-items: center;
  display: flex;
}

.separator {
  color: var(--color-placeholder);
  height: 16px;
  margin: 0 4px;
  width: 16px;
}

.crumb-text {
  color: var(--color-placeholder);
  font-size: 13px;
  font-weight: 500;
}

.right {
  align-items: center;
  display: flex;
  flex-shrink: 0;
  gap: 4px;
}

.headerControl {
  border-radius: 999px;
  height: 44px;
  width: 44px;
}

.organizationSwitch {
  flex: 0 0 136px;
  max-width: 136px;
  min-width: 136px;
  width: 136px;
}

@media (max-width: 768px) {
  .root {
    display: none;
  }
}
